import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { FilterStorageState, TableContext } from './filter.reducer';

export const featureStateName = 'filterFeature';

export const getFilterState = createFeatureSelector<Record<string, FilterStorageState>>(featureStateName);

export const getFilterStateForKey = (
  key: TableContext
): MemoizedSelector<object, FilterStorageState | undefined, DefaultProjectorFn<FilterStorageState | undefined>> =>
  createSelector(getFilterState, filter => (filter[key] ? filter[key] : undefined));
